import React from "react";
import { Link } from "react-router-dom";

const assignments = [
  { id: 1, title: "Principles and Practices", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/idea.jpg`, week: "1. Week" },
  { id: 2, title: "Project Management & Web Development", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/2calendario.jpg`, week: "1. Week" },
  { id: 3, title: "Computer-Aided Design", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/3design.jpg`, week: "2. Week" },
  { id: 4, title: "Computer-Controlled Cutting", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/4iconlaser.jpg`, week: "3. Week" },
  { id: 5, title: "Embedded Programming", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/9_programming.jpg`, week: "4. Week" },
  { id: 6, title: "3D Scanning and Printing", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/6_3dprinting.jpg`, week: "5. Week" },
  { id: 7, title: "Electronics Design", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/7_elecdesign.jpg`, week: "6. Week" },

  { id: 8, title: "Computer-Controlled Machining", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/8_cnc.jpg`, week: "7. Week" },
 { id: 9, title: "Electronics Production", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/5electronic.jpg`, week: "8. Week" },
  { id: 10, title: "Input Devices", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/11_input.jpg`, week: "9. Week" },
  { id: 11, title: "Output Devices", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/12_output.jpg`, week: "10. Week" },
  // { id: 12, title: "Networking and Communication", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/15_networking.jpg`, week: "11. Week" },
  { id: 13, title: "Mechanical Design, Machine Design", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/16_machine_mechanical.jpg`, week: "12. Week" },
  /*{ id: 14, title: "Molding and Casting", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/10_casting.jpg`, week: "13. Week" },
  { id: 15, title: "Interface and Application Programming", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/17_interface.jpg`, week: "14. Week" },
  { id: 16, title: "System Integration", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/13_implications.jpg`, week: "15. Week" },
  { id: 17, title: "Wildcard Week", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/18_Wildcard_vacuum.jpg`, week: "16. Week" },
  { id: 18, title: "Application and Implications - Project Development", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/13_implications.jpg`, week: "17. Week" },
  { id: 19, title: "Invention, Intellectual Property and Income", image: `${process.env.PUBLIC_URL}/assets/weekly_icons/20_cc.jpg`, week: "18. Week" },*/
  { id: 20, title: "Final Project", image: `${process.env.PUBLIC_URL}/assets/placeholder.svg`, week: "Final Project" },
];



const Assignments = () => {
  return (
    <div className="container mx-auto my-8">
      <h2 className="text-3xl font-bold mb-6 text-center">Assignments</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {assignments.map((assignment) => (
          <div key={assignment.id} className="block bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="bg-teal-500 text-white text-center py-2">
              <p className="font-bold">{assignment.week}</p>
            </div>
            <Link to={assignment.id === 20
               ? "/final-project" : `/assignments/${assignment.id}`}>
              <img
                src={assignment.image}
                alt={assignment.title}
                className="w-full h-32 object-contain bg-gray-100"
              />
              <div className="p-4 text-center">
                <h3 className="text-lg font-bold">{assignment.title}</h3>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Assignments;
